import { Outlet } from "react-router-dom";
import Loading from "../../components/Loading";

const LayoutEmpty = () => {
  return (
    <div className="min-h-full bg-slate-100">
      <Outlet />
      <Loading />
    </div>
  );
};

export default LayoutEmpty;
